import { Account } from "@wingspanhq/wingspan-api-sdk";

import { PAYSTUBS_DEFAULT_YEAR } from "./constants";
import { PaystubsYear } from "./types";

const EMPTY_VALUE = "—";

export const getDefaultPaystubsYear = (): PaystubsYear => {
  return PAYSTUBS_DEFAULT_YEAR;
};

/**
 * The `payDate` filter range (`gte`/`lte`) for a paystubs dashboard year. Used to
 * scope the payee's pay-statement list to the selected calendar year — statements
 * without a `payDate` (e.g. unprocessed drafts) fall outside the range and are
 * excluded, which is the desired behaviour for a payee "paystubs" view.
 */
export const getPaystubsYearRange = (
  year: PaystubsYear
): { gte: Date; lte: Date } => {
  const yearNumber = Number(year);
  return {
    gte: new Date(yearNumber, 0, 1, 0, 0, 0, 0),
    lte: new Date(yearNumber, 11, 31, 23, 59, 59, 999)
  };
};

/**
 * The employer (payer) display name shown on the payee's paystubs — the payer
 * account's profile display name, falling back to its legal name.
 */
export const formatPayerName = (account?: Account): string =>
  account?.profile?.displayName ??
  account?.complianceEntity?.legalName ??
  EMPTY_VALUE;
